import { AsyncComponent } from '@frontend/components/common';
import { lazy } from 'react';

const SlotSelectV2 = lazy(() => import('@frontend/slot/select').then((module) => ({ default: module.SlotSelectV2 })));

export interface SlotFieldProps {
    onChange: (value: string | null) => void;
    value: string | null;
    disabled?: boolean;
    className?: string;
    label?: React.ReactNode;
    required?: boolean;
    isClearable?: boolean;
}

export const SlotField = (props: SlotFieldProps) => {
    return (
        <AsyncComponent>
            <SlotSelectV2
                {...props}
                label={props.label || 'SLOT'}
                isClearable={props.isClearable ?? true}
            />
        </AsyncComponent>
    );
};
